import React from 'react';
import styles from './empty.module.css';
import blueSmile from '../../images/blue-smile-with-out-face.svg';

const Empty = () => {
  return (
    <div className={styles.empty}>
      <img
        src={blueSmile}
        alt='Não há nada aqui por enquanto.'
        title='Não há nada aqui por enquanto.'
      />
      <h2>Não há nada aqui por enquanto.</h2>
    </div>
  );
};

export default Empty;
